import { render, staticRenderFns } from "./MessageThreadPanel.vue?vue&type=template&id=519fdecf"
import script from "./MessageThreadPanel.vue?vue&type=script&lang=js"
export * from "./MessageThreadPanel.vue?vue&type=script&lang=js"
import style0 from "./MessageThreadPanel.vue?vue&type=style&index=0&id=519fdecf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports